import NotFoundPage from "../pages/notfound/NotFoundPage";
import QRCodeCheckPage from "../pages/qrcode/QRCodeCheckPage";

export interface RouteEntity {
    path: string;
    relativePath: string;
    component: any;
    title?: string;
    relativePathWithParams?: (params: any) => string;
}

const routes = {
    qrcode: {
        path: "/qrcodes/check/:qrcode",
        relativePath: "/qrcodes/check",
        component: QRCodeCheckPage,
        title: "Verificar QR Code",
        relativePathWithParams: (params: { qrcode: string }) => `/qrcodes/check/${params.qrcode}`,
    },
    notfound: {
        path: "*",
        relativePath: "/404",
        component: NotFoundPage,
        title: "Página no encontrada",
        relativePathWithParams: (params: any) => "/404",
    }
};

export default routes;